import { render, staticRenderFns } from "./ProfileSubscriptionsSummary.vue?vue&type=template&id=1d68f626&scoped=true&"
import script from "./ProfileSubscriptionsSummary.vue?vue&type=script&lang=js&"
export * from "./ProfileSubscriptionsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSubscriptionsSummary.vue?vue&type=style&index=0&id=1d68f626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d68f626",
  null
  
)

export default component.exports